import React from "react";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import SEO from "../components/SEO";

export default function LegalLayout({ title, path, description, children }) {
  return (
    <>
      <SEO
        title={`${title} — Culmora OS`}
        description={description}
        path={path}
      />
      <Header />
      <main id="main" className="pt-10 pb-20">
        <div className="z-page">
          <div className="max-w-[760px] mx-auto">
            <h1 className="font-display text-[clamp(32px,5vw,48px)] leading-[1.05]">
              {title}
            </h1>
            <article className="mt-8 space-y-6 text-[15.5px] leading-[1.7] text-[hsl(var(--z-text-muted))] [&>h2]:mt-8 [&>h2]:text-[hsl(var(--z-text))] [&>h2]:font-display [&>h2]:text-[22px]">
              {children}
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
